import { stringToArray, stringToDate, toTitleCase } from 'common/utils';
import dayjs from 'dayjs';
import { procedureDataType } from 'types/types';

/**
 * Maps CPT lookups to form-compatible structure
 */
const mapCpts = (items: any[] = []) => {
  return items.map(item => ({
    id: item.cpt_lookup.id,
    code: item.cpt_lookup.code,
    rvu_value: item.cpt_lookup.rvu_value,
    value: item.cpt_lookup.value,
    quantity: item.quantity,
  }));
};

const SKIP_NULL_TO_EMPTY = new Set([
  'cpt_modifier',
  'cpt_modifier_id',
]);

/**
 * Normalizes primitive fields and list fields
 * (intentionally mutates the provided object to preserve existing behavior)
 */
const normalizeFields = (data: any) => {
  Object.keys(data).forEach(key => {
    if (
      (data[key] === undefined || data[key] === 'undefined' || data[key] === null) &&
      !SKIP_NULL_TO_EMPTY.has(key)
    ) {
      data[key] = '';
    }

    // Boolean conversion
    if (typeof data[key] === 'boolean') {
      data[key] = data[key] ? '1' : '0';
    }

  });
};

export const mapRegistryPatientToForm = (
  data: any,
): procedureDataType => {
  /**
   * Normalize root procedure fields
   */
  normalizeFields(data);

  /**
   * Dates
   */


  const dob = data.date_of_birth;
  const formattedDob = dob
    ? dayjs(new Date(dob).toISOString().split('T')[0])
    : null;



  const dop = stringToDate(data.date);
  const formattedDop = dop
    ? dayjs(dop.toISOString().split('T')[0])
    : null;

  /**
   * ICDs
   */

  // const icds =
  //   data.procedure_icd?.map((item: any) => ({
  //     ...item.icd_lookup,
  //   })) ?? [];

  /**
   * CPTs (procedure level)
   */
  // const cpts = mapCpts(rest.procedure_cpt);

  /**
   * Co Surgeons
   */
  // const coSurgeons =
  //   rest.co_surgeons?.map((item: any) => ({
  //     invitee_name: item,
  //     selected: true,
  //   })) ?? [];

  /**
   * Primary Surgeons
   */
  // const primarySurgeons =
  //   rest.primary_surgeons?.map((item: any) => ({
  //     invitee_name: item,
  //     selected: true,
  //   })) ?? [];

  /**
   * Case Procedures
   */
  // const caseProcedures =
  //   rest.case_procedures?.map((caseProcedure: any) => {
  //     // Normalize fields per case procedure
  //     normalizeFields(caseProcedure);

  //     return {
  //       ...caseProcedure,
  //       date_of_procedure: caseProcedure.date_of_procedure
  //         ? dayjs(caseProcedure.date_of_procedure)
  //         : null,
  //       cpts: mapCpts(caseProcedure.case_procedure_cpt),
  //       cpt_modifier: caseProcedure.cpt_modifier ?? null,
  //       cpt_modifier_id: caseProcedure.cpt_modifier?.id ?? null,
  //     };
  //   }) ?? [];

  /**
   * Final mapped object
   */

  if (data.institute && typeof data.institute !== 'string') {
    data.institute = {
      key: data?.institute?.id,
      label: data.institute.label,
      value: data.institute.id,
    }
  }

  return {
    ...data,
    gender: toTitleCase(data.gender),
    date_of_birth: formattedDob,
    date: formattedDop ?? dayjs(),
    institute: data?.institute?.key ?? data.institute,
    // cpts,
    // icds,
    // notes: data?.notes?.map((item: any) => item.note) ?? [],
  };
};
